import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';
import './App.less';
import Header from './Component/Header';
import Headbar from './Component/Headbar'; 
import Condition from './Page/Condition';
import Home from './Page/Home';
import Indemnify from './Page/Indemnify';
import PersonalInFor from './Page/PersonalInFor';
import UploadFiles from './Page/UploadFiles';
import UploadSuccess from './Page/UploadSuccess';
import Success from './Page/Success';
import ScrollTo from './Component/ScrollTo';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import QueryClaim from './Component/QueryClaim';

function App() {
    return (
        <BrowserRouter>
            <QueryParamProvider adapter={ReactRouter6Adapter}>
                <ScrollTo />
                <QueryClaim />
                <Header />
                <ConditionalHeadbar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path=":slug" element={<Indemnify />} />
                    <Route path="/condition" element={<Condition />} />
                    <Route path="/upload-files" element={<UploadFiles />} />
                    <Route path="/upload-success" element={<UploadSuccess />} />
                    <Route path="/personal-information" element={<PersonalInFor />} />
                    <Route path="/success" element={<Success />} />
                </Routes> 
            </QueryParamProvider>  
        </BrowserRouter>
    );
}

const ConditionalHeadbar = () => {
    const location = useLocation();
    const showHeadbar = ['/personal-information', '/upload-files', '/upload-success', '/success'].includes(location.pathname);
    
    return showHeadbar ? <Headbar /> : null;
};

export default App;